import PropTypes from "prop-types";
import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { FaUsers, FaUserCheck, FaCreditCard, FaUserPlus } from 'react-icons/fa';
import { MdOutlineCardMembership, MdSubscriptions } from "react-icons/md";

const CardDashboard = ({ dashboard }) => {
    const {
        total_registered_users,
        total_registered_users_7days,
        total_active_users_7days,
        total_members,
        total_subscribers,
        total_membership_purchase_amount,
        total_subscribe_purchase_amount
    } = dashboard;

    return (
        <React.Fragment>
            <Row className="justify-content-center">
                <Col xl={3} sm={6} className="mb-4 d-flex justify-content-center">
                    <Card className="shadow p-3 mb-5 bg-white" style={{ minHeight: '200px', width: '100%', maxWidth: '400px' }}>
                        <CardBody className="text-center">
                            <FaUsers size={40} className="text-primary mb-3" />
                            <h5 className="font-size-20 text-muted">Total Registered Users</h5>
                            <h3>{total_registered_users}</h3>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} sm={6} className="mb-4 d-flex justify-content-center">
                    <Card className="shadow p-3 mb-5 bg-white" style={{ minHeight: '200px', width: '100%', maxWidth: '400px' }}>
                        <CardBody className="text-center">
                            <FaUserPlus size={40} className="text-success mb-3" />
                            <h5 className="font-size-20 text-muted">Registered Users in 7 Days</h5>
                            <h3>{total_registered_users_7days}</h3>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} sm={6} className="mb-4 d-flex justify-content-center">
                    <Card className="shadow p-3 mb-5 bg-white" style={{ minHeight: '200px', width: '100%', maxWidth: '400px' }}>
                        <CardBody className="text-center">
                            <FaUserCheck size={40} className="text-warning mb-3" />
                            <h5 className="font-size-20 text-muted">Active Users in 7 Days</h5>
                            <h3>{total_active_users_7days}</h3>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} sm={6} className="mb-4 d-flex justify-content-center">
                    <Card className="shadow p-3 mb-5 bg-white" style={{ minHeight: '200px', width: '100%', maxWidth: '400px' }}>
                        <CardBody className="text-center">
                            <MdOutlineCardMembership
                                size={40} className="text-primary mb-3" />
                            <h5 className="font-size-20 text-muted">Total Members</h5>
                            <h3>{total_members}</h3>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} sm={6} className="mb-4 d-flex justify-content-center">
                    <Card className="shadow p-3 mb-5 bg-white" style={{ minHeight: '200px', width: '100%', maxWidth: '400px' }}>
                        <CardBody className="text-center">
                            <MdSubscriptions  size={40} className="text-info mb-3" />
                            <h5 className="font-size-20 text-muted">Total Subscribers</h5>
                            <h3>{total_subscribers}</h3>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} sm={6} className="mb-4 d-flex justify-content-center">
                    <Card className="shadow p-3 mb-5 bg-white" style={{ minHeight: '200px', width: '100%', maxWidth: '400px' }}>
                        <CardBody className="text-center">
                            <FaCreditCard size={40} className="text-success mb-3" />
                            <h5 className="font-size-20 text-muted">Total Membership Purchase amount</h5>
                            <h3>₹ {total_membership_purchase_amount}</h3>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl={3} sm={6} className="mb-4 d-flex justify-content-center">
                    <Card className="shadow p-3 mb-5 bg-white" style={{ minHeight: '200px', width: '100%', maxWidth: '400px' }}>
                        <CardBody className="text-center">
                            <FaCreditCard size={40} className="text-info mb-3" />
                            <h5 className="font-size-20 text-muted">Total Subscription Purchase amount</h5>
                            <h3>₹ {total_subscribe_purchase_amount}</h3>
                        </CardBody>
                    </Card>
                </Col>

            </Row>
        </React.Fragment>
    );
};

CardDashboard.propTypes = {
    dashboard: PropTypes.object.isRequired,
};

export default CardDashboard;
